var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-common-config',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"fieldSpecific",fn:function(ref){
var rec = ref.rec;
return [_vm._v(" "+_vm._s(rec)+" ")]}}])},'form-common-config',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }